import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './lang/en.js'
import cn from './lang/zh.js'
import './index.css'

Vue.use(VueI18n)

// cookie读取配置
const getCookie = function(n){
    var a,r=new RegExp("(^| )"+n+"=([^;]*)(;|$)");
    try{
        if (a = document.cookie.match(r)) {
            return decodeURIComponent(a[2]);
        } else {
            return "";
        }
    }catch(e){
        return "";
    }
}

// url读取配置
const getUrlParams = function (id) {
    let params = window.location.search.slice(1);
    params = params.split('&');
    let urlParams = {};
    params.forEach((item)=>{
        item = item.split('=');
        urlParams[item[0]] = item[1];
    })
    if (!id) return urlParams;
    return urlParams[id];
}

// 多语言配置的读取顺序
// url -> cookie -> zh 
let lang = getUrlParams('lang');
if (!lang) {
  lang = getCookie('ifindlang');
}
if (!lang) lang = 'cn';
window.lang = lang;
document.body.classList.add(lang);

const i18n = new VueI18n({
  locale: lang,
  messages: {
    'cn': { ...cn },
    'en': { ...en }
  }
})

// 扩展多语言配置格式化
i18n.$e = (key, values) => {
  let result = i18n.t(key);
  if (Array.isArray(values) && values.length) {
    values.forEach((v)=> {
        result = result.replace(/%s/, v);
    });
  }
  return result;
}
window.$t = function(key) {
  return i18n.t(key);
};
window.$extend = function(key, values) {return i18n.$e(key, values)};
Vue.prototype.$extend = function (key, values) {
  const i18n = this.$i18n
  return i18n.$e(key, values);
}
window.$if = function(s1, s2) {
  if (window.lang === 'en') {
    return s2;
  } else {
    return s1;
  }
}
export default i18n